import { render, staticRenderFns } from "./MedicationRecord.vue?vue&type=template&id=728d10c6&"
import script from "./MedicationRecord.vue?vue&type=script&lang=js&"
export * from "./MedicationRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports